import Vue from "vue";
import ApolloClient from "apollo-boost";
import VueApollo from "vue-apollo";
// import router from "@/router/index";

export const apolloClient = new ApolloClient({
    uri:
        process.env.NODE_ENV === "production"
            ? "/graphql/"
            : "http://127.0.0.1:8000/graphql/",
    request: operation => {
        const token = localStorage.getItem("token");
        // console.log(token);
        operation.setContext({
            headers: {
                authorization: token ? `JWT ${token}` : ""
            }
        });
    }
});

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
        $loadingKey: "loading"
    },
    errorHandler(error) {
        console.log("Global apollo error handler");
        console.error(error);
        // if (isNotFound(error)) {
        //   router.history.updateRoute(router.match("/not_found"));
        //   return true; // we handled the error, stop propagation
        // }
    }
});

// Install the vue plugin
Vue.use(VueApollo);

export default apolloProvider;
